
import { PropTypes } from 'prop-types';
const Card = ({icon,title,description,position="items-center"}) => {
  return (
    <div className={`flex flex-col justify-between gap-4 ${position}`}>
        <img src={icon} className='w-16 h-16' alt="photo" />
        <h2 className="text-slate-900 text-2xl  font-bold leading-tight">{title}</h2>
        <p className="w-auto  text-sky-950 text-opacity-70 whitespace-pre-line text-base font-normal leading-normal">{description}</p>
    </div>
  )
}
Card.propTypes = {
    icon:PropTypes.element,
    title:PropTypes.string,
    description:PropTypes.any,
    position:PropTypes.string
}
export default Card